import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  CircularProgress,
  IconButton,
  Dialog,
  DialogContent,
  DialogActions,
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import ClearIcon from "@mui/icons-material/Clear";
import DeleteIcon from "@mui/icons-material/Delete";
import { IconEye } from "@tabler/icons";
import clsx from "clsx";
import axios from "axios";
import useRequestIdGenerater from "customhooks";
import useTimeStamp from "reuseableTable/uniquetimestamp/GenerateUniqueTimeStamp";

const EventCover = ({
  hoverLabel = "Click or drag to upload file.",
  dropLabel = "Drop file here.",
  width = "1200px",
  height = "100px",
  backgroundColor = "#fff",
  onChange,
  setValue,
  setImageArray,
  imageArray,
}) => {
  const [labelText, setLabelText] = useState(hoverLabel);
  const [isDragOver, setIsDragOver] = useState(false);
  const [uploadingFileIndex, setUploadingFileIndex] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const Uuid = localStorage.getItem("uuid");


  const stopDefaults = (e) => {
    e.stopPropagation();
    e.preventDefault();
  };

  const dragEvents = {
    onDragEnter: (e) => {
      stopDefaults(e);
      setIsDragOver(true);
      setLabelText(dropLabel);
    },
    onDragLeave: (e) => {
      stopDefaults(e);
      setIsDragOver(false);
      setLabelText(hoverLabel);
    },
    onDragOver: stopDefaults,
    onDrop: (e) => {
      stopDefaults(e);
      setLabelText(hoverLabel);
      setIsDragOver(false);
      handleDrop(e);
    },
  };

  const CHUNK_SIZE = 1 * 900 * 900;
  const ConvertToRequestId = useRequestIdGenerater();
  const { rendomRequestId, generateTimeStamp } = useTimeStamp();


  const uploadChunk = async (file, chunk, chunkIndex, totalChunks) => {
    const formData = new FormData();
    formData.append("file", chunk);
    formData.append("chunkIndex", chunkIndex);
    formData.append("totalChunks", totalChunks);
    formData.append("fileName", file.name);

    return axios.post(
      "/v1/upload",
      formData,
      {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("serviceToken")}`,
          "Content-Type": "multipart/form-data",
          requestId: ConvertToRequestId(
            Math.floor(1000 + Math.random() * 9999),
            Math.floor(1000 + Math.random() * 9999) + rendomRequestId
          ),
        },
      }
    );
  };

  const handleChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      handleFile(file);
    }
  };

  const handleDrop = (event) => {
    stopDefaults(event);
    const file = event.dataTransfer.files[0]; // Only one file allowed
    if (file) {
      handleFile(file);
    }
  };

  const handleFile = async (file) => {
    const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
    let uploadedFilePath = null;
    let preSignedUrl = null;

    for (let i = 0; i < totalChunks; i++) {
      const chunk = file.slice(i * CHUNK_SIZE, (i + 1) * CHUNK_SIZE);
      try {
        const response = await uploadChunk(file, chunk, i, totalChunks);
        if (i === totalChunks - 1) {
          uploadedFilePath = response.data?.data?.filePath;
          preSignedUrl = response.data?.data?.preSignedUrl;
        }
      } catch (error) {
        console.error("Error uploading chunk:", error);
        return;
      }
    }

    if (uploadedFilePath && preSignedUrl) {
      // Replace the existing image with the new one
      setImageArray([{ filePath: uploadedFilePath, previewUrl: preSignedUrl }]);
      setValue("coverIcon", uploadedFilePath)
    }
  };



  const deleteImage = (index) => {
    const updatedArray = [...imageArray];
    updatedArray.splice(index, 1);
    setImageArray(updatedArray);
    setLabelText(hoverLabel);
  };

  const handleClickOpenDialog = (image) => {
    setSelectedImage(image);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  useEffect(() => {
    generateTimeStamp()
  }, [])

  return (
    <Box
      border={`2px dashed ${isDragOver ? "blue" : "#aaa"}`}
      borderRadius="8px"
      padding="16px"
      textAlign="center"
      width={width}
      height={height}
      bgcolor={backgroundColor}
      {...dragEvents}
      className={clsx("file-upload", isDragOver && "file-upload--drag-over")}
    >
      {imageArray.length === 0 ? (
        <>
          <input
            onChange={handleChange}
            accept="image/jpeg, image/jpg, image/png"
            style={{ display: "none" }}
            id="file-upload"
            type="file"
          />

          <label htmlFor="file-upload">
            <CloudUploadIcon fontSize="large" />
            <Typography>{labelText}</Typography>
          </label>
        </>
      ) : (
        imageArray.map((fileObj, index) => (
          <div key={index} style={{ marginTop: "10px" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "10px",
              }}
            >
              <Typography>{fileObj?.filePath}</Typography>
              <div>
                <IconButton
                  onClick={() => handleClickOpenDialog(fileObj.previewUrl)}
                >
                  <IconEye sx={{ color: "blue" }} />
                </IconButton>
                <IconButton onClick={() => deleteImage(index)}>
                  <DeleteIcon />
                </IconButton>
              </div>
            </div>
          </div>
        ))
      )}

      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogActions>
          <IconButton onClick={() => handleCloseDialog()}>
            <ClearIcon />
          </IconButton>
        </DialogActions>
        <DialogContent>
          <img src={selectedImage} alt="Preview" style={{ width: "100%" }} />
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default EventCover;
